import { WorkModel } from '@Entities/work/work'
import { WorksFromUpload } from '@Entities/work/works-from-upload'

export const findWorkByLocalId = (localId: string, arrayAllWorks: WorksFromUpload) => {
    const errorWork = arrayAllWorks.error.find((item: WorkModel) => item.localId === localId)
    const completeWork = arrayAllWorks.complete.find((item: WorkModel) => item.localId === localId)

    if (errorWork) {
        return errorWork
    } else if (completeWork) {
        return completeWork
    } else {
        return
    }
}
